import Typography from "@mui/material/Typography";
import isEmpty from "lodash/isEmpty";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";

type FooterLinkItem = {
  label: string;
  path: string;
};

type LinksContainerProps = {
  heading: string;
  list: FooterLinkItem[];
};

const LinksContainer = ({ heading, list }: LinksContainerProps) => {
  if (isEmpty(list)) return null;

  return (
    <div className={styles.linksContainer}>
      <div className={styles.heading}>
        <Typography variant="h4" component="h4" fontWeight="bold">
          {heading}
        </Typography>
        <hr />
      </div>
      <div className={styles.linkList}>
        {list.map((item: FooterLinkItem, index: number) => (
          <Link key={index} className={styles.links} to={item.path}>
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LinksContainer;
